import {Component, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {SelectOption} from 'src/app/shared/models/select-option';
import {distinctUntilChanged, map} from 'rxjs/operators';

@Component({
    selector: "app-select-input",
    templateUrl: "./select-input.component.html",
    styleUrls: ["./select-input.component.scss"]
})
export class SelectInputComponent implements OnInit, OnChanges {
    control = new FormControl("");

    @Input() items: SelectOption<any>[];
    @Input() value;
    @Input() placeholder = "";
    @Input() requiredMessage = "";
    @Input() appendTo;
    @Input() disabled: boolean = false;
    @Input() clearable = true;
    @Input() searchable = true;
    @Output() valueChange = this.control.valueChanges.pipe(
        map(item => item?.value),
        distinctUntilChanged()
    );

    constructor() {}

    ngOnInit() {
        if (this.requiredMessage) {
            this.control.setValidators(Validators.required);
        }

        if(this.disabled) {
            this.control.disable();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        this.control.setValue(this.items.find(i => i.value === this.value));
    }
}
